import { useEffect, useState } from "react";
import cnBind from "classnames/bind";
import Link from "next/link";
import { ModalCaseBlock } from "@/components/_Modals/ModalCaseBlock";
import { GetPortfolioDto } from "@/entities/types/entities";
import { Routes } from "@/shared/constants";
import { API_BASE } from "@/shared/constants/private";
import { useBooleanState } from "@/shared/hooks";
import { CaseCard } from "@/view/Main/component/CaseBlock/component";
import styles from "./CaseBlock.module.scss";
import axios from "axios";

// ИМПОРТ СВАЙПЕРА
import { Swiper, SwiperSlide } from "swiper/react";
import { Scrollbar } from "swiper/modules";
import "swiper/css";
import "swiper/css/scrollbar";

const cx = cnBind.bind(styles);

type Props = {
    sectionId?: string;
    categoryId?: string;
    businessId?: string;
    sectionNumber?: number;
    categoryNumber?: number;
    businessNumber?: number;
};

export const CaseBlock = ({ sectionId, categoryId, businessId, sectionNumber, categoryNumber, businessNumber }: Props) => {
    const [portfolios, setPortfolios] = useState<GetPortfolioDto[]>([]);
    const [isOpen, onOpen, onClose] = useBooleanState(false);
    const [current, setCurrent] = useState<GetPortfolioDto | null>(null);

    const handleOnModal = (i: GetPortfolioDto) => {
        setCurrent(i);
        onOpen();
    };

    const handleOnClose = () => {
        onClose();
        setCurrent(null);
    };

    useEffect(() => {
        void (async () => {
            try {
                const response = await axios.get<GetPortfolioDto[]>(`${API_BASE}/portfolio`, {
                    params: {
                        onlyPublished: true,
                        limit: 8,
                        ...(sectionId && { sectionId }),
                        ...(categoryId && { categoryId }),
                        ...(businessId && { businessId }),
                    },
                });
                setPortfolios(response.data);
            } catch (err) {
                console.error("Ошибка при загрузке Portfolio:", err);
                setPortfolios([]);
            }
        })();
    }, [sectionId, categoryId, businessId]);

    if (!portfolios.length) return null;

    const queryParams: Record<string, string> = {};
    if (sectionNumber) queryParams.section = String(sectionNumber);
    if (categoryNumber) queryParams.category = String(categoryNumber);
    if (businessNumber) queryParams.business = String(businessNumber);

    return (
        <div className={cx("case-block")}>
            <div className={cx("wrapper", "container")}>
                <h2>Портфолио</h2>

                <Swiper
                    modules={[Scrollbar]}
                    scrollbar={{ draggable: true }}
                    className={cx("cards")}
                    slidesPerView={"auto"}
                    spaceBetween={16}
                    breakpoints={{
                        1201: {
                            slidesPerView: 4,
                            spaceBetween: 24,
                            allowTouchMove: portfolios.length > 4,
                        },
                        769: {
                            slidesPerView: "auto",
                            spaceBetween: 24,
                            allowTouchMove: true,
                        }
                    }}
                >
                    {portfolios.map((el, index) => (
                        <SwiperSlide key={index}>
                            <div className={cx("card-wrapper")} onClick={() => handleOnModal(el)}>
                                <CaseCard image={`${API_BASE}/picture/${el.pictureId}`} {...el} />
                            </div>
                        </SwiperSlide>
                    ))}
                </Swiper>

                <div className={cx("more-link-wrapper")}>
                    <Link href={{ pathname: Routes.PORTFOLIO, query: queryParams }} className={cx("more-text-link")} >
                        Посмотреть все
                    </Link>
                </div>
            </div>
            <ModalCaseBlock isOpen={isOpen} onClose={handleOnClose} item={current !== null ? current : ({} as GetPortfolioDto)} />
        </div>
    );
};
